import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import { SCORE_TOOLTIP } from "@/v2-backoffice-client/usage/usage.constants"

export type UsageScoreMeterProps = ComponentProps<"div"> & {
  score: number | null | undefined
}

// 0-100 track with the four band zones tinted (red / amber / green /
// strong green) and a marker at the score, so "63" reads as a position on
// a scale instead of a bare number.
function UsageScoreMeter(props: UsageScoreMeterProps) {
  const { score, className, ...divProps } = props

  if (score == null) return null

  return (
    <div
      className={cn("usage-score-meter", className)}
      role="img"
      aria-label={`Engagement score ${score} of 100`}
      title={SCORE_TOOLTIP}
      {...divProps}
    >
      <div
        className="usage-score-meter-marker"
        style={{ left: `${Math.min(100, Math.max(0, score))}%` }}
      />
    </div>
  )
}

export default UsageScoreMeter
